<template>
  <!-- Phones: filters live in a bottom sheet behind a "Filter" button,
       so the table is not pushed far below a long form. -->
  <div v-if="isMobile" class="esign-filter-bar">
    <v-btn outlined color="primary" class="esign-filter-bar__btn" @click="open = true">
      <v-icon left>mdi-filter-variant</v-icon>Filter
    </v-btn>
    <v-bottom-sheet v-model="open" scrollable eager>
      <v-card class="esign-filter-sheet">
        <v-card-title class="esign-filter-sheet__head">
          <span>Filter</span>
          <v-spacer />
          <v-btn icon aria-label="Tutup filter" @click="open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- the page's own "Cari" button applies the filters, then the sheet closes -->
        <v-card-text class="esign-filter-sheet__body" @click="closeOnApply">
          <slot />
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
  </div>
  <div v-else>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'EsignFilterPanel',
  data: () => ({
    open: false,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    },
  },
  methods: {
    closeOnApply(event) {
      if (event.target.closest('.v-btn:not(.v-btn--icon)')) {
        this.open = false
      }
    },
  },
}
</script>
